import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface FooterProps {
  onClose: () => void
}

interface canManageProps extends FooterProps {
  onOpenEditSidepanel: () => void
}

export const CanManageFooter = ({ onClose, onOpenEditSidepanel }: canManageProps) => {
  const onClickEdit = () => {
    onClose()
    onOpenEditSidepanel()
  }
  return (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.close')}
      </Button>
      <Button type="primary" onClick={onClickEdit}>
        {i18n.t('common.edit')}
      </Button>
    </>
  )
}

export const ReadOnlyFooter = ({ onClose }: FooterProps) => {
  return (
    <Button type="primary" onClick={onClose}>
      {i18n.t('common.close')}
    </Button>
  )
}
